import React from 'react';
import styled from 'styled-components';
import { copyFor } from '../../copy/copy';

const SponsoredContainer = styled.div`
    display: flex;
    align-items: center;

    font-size: 10px;
    color: #6c6c6c;
    border-style: solid;
    border-width: 1px;
    border-color: #dbdbdb;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;
    padding: 0 6px 3px;
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%);
`;

export const SponsoredTag = props => (
    <SponsoredContainer>{copyFor('miscellaneous', 'sponsored')}</SponsoredContainer>
);



// WEBPACK FOOTER //
// ./src/components/Widget/SponsoredTag.jsx